import type { PdpConfig } from '#types/config/pages/pdp'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    sizeChartDialog: 'lg:w-208'
  },
  gallery: {
    presets: {
      src: {
        unSharpMask: 100
      },
    },
    videoFit: 'cover',
  }
} satisfies RecursivePartial<PdpConfig>
